<template>
  <div class="mx-10 rating-container" ref="rating-container">
    <div class="rating-text">
      {{ratingText}}
    </div>
    <v-btn
      fab
      class="rating-icon-container"
      :style="ratingIconContainerStyle"
      @touchmove.stop.prevent="touchMoveHandler"
      @mousedown.stop.prevent="mouseDownHandler"
      @mousemove.stop.prevent="mouseMoveHandler"
    >
      <v-icon class="rating-icon outline">mdi-circle</v-icon>
      <v-icon class="rating-icon" :color="ratingIconColor">mdi-star</v-icon>
    </v-btn>
  </div>
</template>

<style scoped>
.rating-container {
  position: relative;
  height: 75px;
}
.rating-text {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: white;
}
.rating-icon-container {
  position: relative;
}
.rating-icon {
  position: absolute;
  transform: scale(2.6);
  transition: none;
}
.rating-icon.outline {
  color: rgba(255, 255, 255, 0.8);
  transform: scale(3.5);
}
</style>

<script>
export default {
  name: 'rating-input',
  components: {
  },
  props: [ 'disabled' ],
  data() {
    return {
      rating: null
    };
  },
  computed: {
    ratingText() {
      if (this.rating === null) {
        return;
      }
      if (this.rating < -0.75) {
        return 'Not for me';
      }
      if (this.rating < -0.25) {
        return 'Eh…';
      }
      if (this.rating < 0.25) {
        return 'Nice!';
      }
      if (this.rating < 0.75) {
        return 'Awesome!';
      }
      return 'LOVE IT';
    },
    ratingIconContainerStyle() {
      const xPct = 100 * (this.rating + 1) / 2;
      const yPct = 60 * this.rating ** 2;
      const left = 'calc(' + xPct + '% - 28px)';
      const top = 'calc(' + yPct + '% - 28px)';
      return { left, top };
    },
    ratingIconColor() {
      if (this.rating === null) {
        return 'white';
      }
      const interpolate = [ [ 158, 158, 158 ], [ 33, 150, 243 ], [ 255, 193, 6 ] ];
      const i = Math.round((this.rating + 1) / 2);
      const rgb = new Array(3);
      for (let j = 0; j < 3; j++) {
        const fromColorValue = interpolate[i][j];
        const toColorValue = interpolate[i + 1][j];
        const x = this.rating < 0 ? 1 + this.rating : this.rating;
        const y = (toColorValue - fromColorValue) * x + fromColorValue;
        rgb[j] = y;
      }
      return 'rgb(' + rgb.join(',') + ')';
    }
  },
  methods: {
    moveHandler(clientX) {
      if (this.disabled) {
        return;
      }

      // Determine the total offset for the target element
      let clientOffsetLeft = this.$refs['rating-container'].offsetLeft;
      let offsetParent = this.$refs['rating-container'].offsetParent;
      while (offsetParent) {
        clientOffsetLeft += offsetParent.offsetLeft;
        offsetParent = offsetParent.offsetParent;
      }

      // This is the x position within the rating-container
      const w = this.$refs['rating-container'].offsetWidth;
      const x = clientX - clientOffsetLeft;
      if (x < 0 || x > w) {
        // This touch is outside the target
        return;
      }

      this.rating = 2 * ((x / w) - 0.5);
    },
    mouseDownHandler(e) {
      this.isMouseDownInside = true;
      const mouseUpHandler = () => {
        this.isMouseDownInside = false;
        window.removeEventListener('mouseup', mouseUpHandler);
      };
      window.addEventListener('mouseup', mouseUpHandler);
    },
    mouseMoveHandler(e) {
      if (this.isMouseDownInside) {
        this.moveHandler(e.clientX);
      }
    },
    touchMoveHandler(e) {
      if (e.touches.length !== 1) {
        // Ignore multi-touch
        return;
      }
      this.moveHandler(e.touches[0].clientX);
    }
  }
}
</script>
